import gql from "graphql-tag";

export default gql`query BillTemplates {
    billTemplates {
        id    
        name
        category {
            id
            shortname
        }
      }
  }`